export const TICK_SPACINGS = {
  100: 600,
  500: 600,
  3000: 600,
  10000: 600,
}
